// Important: polyfills must come before the other imports!
import "@formatjs/intl-numberformat/polyfill";
import "@formatjs/intl-numberformat/locale-data/en";
import "@formatjs/intl-numberformat/locale-data/de";
// Global font (Inter) shared by every mandator. Brand-specific fonts are loaded
// on demand per mandator via useMandatorFonts (see hooks/useMandatorFonts.tsx).
import "@rentablo/theming/fonts/inter.css";

import "./errorReporting";
import React from "react";
import { createRoot } from "react-dom/client";
import "@translations/i18n";
import { initAxios } from "@rentablo/api";
import { ENUM_COMPATIBILITY_VERSION } from "@constants";
import { configureBankImport } from "@rentablo/bank-import";
import { App } from "./App.tsx";
import * as serviceWorker from "./serviceWorker";
import { initGTM } from "./gtm";
import "@components/Chart/highcharts/highchartsInit";

if (import.meta.env.VITE_APP_ENVIRONMENT === "mock") {
  const { worker } = require("./mocks/browser");
  worker.start();
}

initAxios({
  baseURL: import.meta.env.VITE_APP_API_BASE_URL!,
  legacyURL: import.meta.env.VITE_APP_WEB_API_URL!,
  rentabloURL: import.meta.env.VITE_APP_API_RENTABLO_URL!,
  v3URL: import.meta.env.VITE_APP_API_V3_BASE_URL,
  enumCompatibilityVersion: ENUM_COMPATIBILITY_VERSION,
});

// @rentablo/bank-import ships prebuilt, so import.meta.env inside it would hold
// whatever the publishing machine had. Its environment comes from here instead.
configureBankImport({
  v2Url: import.meta.env.VITE_APP_V2_URL!,
  tppWebFormUrl: import.meta.env.VITE_APP_TPP_WEB_FORM_URL!,
  tutorialImagesBucketUrl: import.meta.env.VITE_TUTORIAL_IMAGES_BUCKET_URL,
  environment: import.meta.env.VITE_APP_ENVIRONMENT,
  language: import.meta.env.VITE_APP_LANGUAGE,
  appName: import.meta.env.VITE_APP_NAME,
});

initGTM();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
